// wishlist_fast_check 

document.addEventListener('DOMContentLoaded', function () {
  
  var element = document.getElementById("button_icon_wishlist");
  var element_mobile = document.getElementById("button_icon_wishlist_mobile");
  if (localStorage.getItem('shopify-wishlist'))
  {
    element.classList.add("wishlist_icon_active");
  	element_mobile.classList.add("wishlist_icon_active");
  }
  
});
